import type { TagColor } from '@billy/design-system'

import type { ImportedInvoiceStatus } from '../../../types/importedInvoiceStatus'

interface ImportedInvoiceIntakeStatusTag {
  color: TagColor
  labelKey: string
}

export const importedInvoiceIntakeStatusToTag: Partial<Record<ImportedInvoiceStatus, ImportedInvoiceIntakeStatusTag>> =
  {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- keyed by the API's snake_case intake status
    to_review: {
      color: 'blue',
      labelKey: 'imported_invoices.intake_status.to_review',
    },
  }
